import { render, staticRenderFns } from "./BaseImageUploader.vue?vue&type=template&id=2683422e&scoped=true&"
import script from "./BaseImageUploader.vue?vue&type=script&lang=js&"
export * from "./BaseImageUploader.vue?vue&type=script&lang=js&"
import style0 from "./BaseImageUploader.vue?vue&type=style&index=0&id=2683422e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2683422e",
  null
  
)

export default component.exports